var React = require('react');

function HeartFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.994 23.882l11.02-11.137A6.876 6.876 0 0 0 27 7.88a6.838 6.838 0 0 0-1.974-4.86 6.63 6.63 0 0 0-4.767-2.002 6.65 6.65 0 0 0-4.772 2.008l-1.478 1.5-1.49-1.512a6.67 6.67 0 0 0-9.54-.012A6.845 6.845 0 0 0 1 7.864c0 1.834.706 3.552 1.992 4.857l11.002 11.161z","fill":"#E01356","fillRule":"nonzero","stroke":"#FFF","strokeWidth":"2"}));
}

HeartFilled.defaultProps = {"width":"28","height":"25"};

module.exports = HeartFilled;

HeartFilled.default = HeartFilled;
